export default {
  name: 'AudioMixin',
  data() {
    return {
      AUD_context: null,
      AUD_node: null,
      AUD_stream: null,
      AUD_volumeMeter: 0,
      AUD_mediaStreamSource: null,
      AUD_devices: [],
      AUD_deviceId: null,
      AUD_gainNode: null,
      AUD_destination: null,
      AUD_gainValue: 1,
      AUD_analyzer: null,
      AUD_deviceLoading: false,
      AUD_noMicId: 'no-microphone',
    };
  },

  created() {
    if (
      !window.navigator.mediaDevices &&
      !window.navigator.mediaDevices.getUserMedia
    ) {
      console.warn('Media Devices are not supported from your browser.');
      return;
    }
    if (window.localStorage.audioSourceID) {
      this.AUD_deviceId = window.localStorage.audioSourceID;
    }
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    this.AUD_context = new AudioContext();
  },

  beforeDestroy() {
    this.AUD_stopStream();
    this.AUD_context.close();
    this.AUD_context = null;
  },

  watch: {
    AUD_gainValue() {
      if (this.AUD_gainNode) {
        this.AUD_gainNode.gain.value = this.AUD_gainValue;
      }
    },
  },
  computed: {
    AUD_isNoMicrophone() {
      return this.AUD_deviceId === this.AUD_noMicId;
    },
  },
  methods: {
    AUD_changeDevice(deviceId) {
      this.AUD_deviceId = deviceId;
      if (!this.AUD_isNoMicrophone) {
        window.localStorage.setItem('audioSourceID', deviceId);
      }
    },

    AUD_stopStream() {
      return new Promise((resolve, reject) => {
        if (this.AUD_node) {
          this.AUD_node.shutdown();
          this.AUD_node = null;
        }
        if (this.AUD_stream) {
          this.AUD_stream.getTracks().forEach((t) => t.stop());
          this.AUD_stream = null;
        }
        resolve();
      });
    },

    async AUD_startStream() {
      await this.AUD_stopStream();

      return new Promise((resolve, reject) => {
        if (!this.REC_microphonePermissions || this.AUD_isNoMicrophone) {
          this.AUD_volumeMeter = 0;
          return resolve(); // we allow video recording even if no microphone is available
        }
        try {
          this.AUD_deviceLoading = true;
          this._getAudioUserMedia()
            .then(() => {
              this.AUD_deviceLoading = false;
              resolve();
            })
            .catch((e) => {
              throw e;
            });
        } catch (e) {
          this.AUD_deviceLoading = false;
          reject(e);
        }
      });
    },

    async _getAudioUserMedia() {
      return new Promise((resolve, reject) => {
        if (this.AUD_deviceId) {
          const findAudioDevice = this.REC_devices.audio.filter((aud) => {
            return aud.id === this.AUD_deviceId;
          });
          if (!findAudioDevice.length) {
            this.AUD_deviceId = null;
          }
        }
        const constraints = {
          audio: {
            deviceId: this.AUD_deviceId
              ? { exact: this.AUD_deviceId }
              : undefined,
            echoCancellation: true,
          },
        };
        window.navigator.mediaDevices
          .getUserMedia(constraints)
          .then((stream) => {
            this.AUD_stream = stream;

            if (!this._isDestroyed) {
              this.AUD_mediaStreamSource =
                this.AUD_context.createMediaStreamSource(this.AUD_stream);
              this.AUD_stream.getTracks().forEach(async (t) => {
                const settings = t.getSettings();
                if (t.kind === 'audio') {
                  this.AUD_deviceId = settings.deviceId;
                }
              });
              this._createAudioGain();
              this._createAudioMeter();
              resolve();
            } else {
              this.AUD_stopStream();
              reject('media allowed after discarding modal');
            }
          }, reject);
      });
    },

    _createAudioGain() {
      this.AUD_destination = this.AUD_context.createMediaStreamDestination();
      this.AUD_gainNode = this.AUD_context.createGain();
      this.AUD_gainNode.gain.value = this.AUD_gainValue;
      [
        this.AUD_mediaStreamSource,
        this.AUD_gainNode,
        this.AUD_destination,
      ].reduce((a, b) => a && a.connect(b));
      // // override stream with gained values
      this.AUD_mediaStreamSource = this.AUD_context.createMediaStreamSource(
        this.AUD_destination.stream
      );
    },

    _createAudioMeter() {
      this.AUD_node = this.AUD_context.createScriptProcessor(2048, 1, 1);
      this.AUD_analyzer = this.AUD_context.createAnalyser();
      this.AUD_analyzer.smoothingTimeConstant = 0.5;
      this.AUD_analyzer.fftSize = 256;
      this.AUD_mediaStreamSource.connect(this.AUD_analyzer);
      this.AUD_analyzer.connect(this.AUD_node);
      this.AUD_node.connect(this.AUD_destination);
      this.AUD_node.shutdown = function () {
        this.disconnect();
        this.onaudioprocess = null;
      };
      this.AUD_node.onaudioprocess = () => {
        const array = new Uint8Array(this.AUD_analyzer.frequencyBinCount);
        this.AUD_analyzer.getByteFrequencyData(array);
        let values = 0;

        const length = array.length;
        for (let i = 0; i < length; i++) {
          values += array[i];
        }

        const average = values / length;

        this.AUD_volumeMeter = Math.round(average);
      };
    },

    // _createAudioMeter() {
    //   this.AUD_node = this.AUD_context.createScriptProcessor(2048, 1, 1);
    //   this.AUD_mediaStreamSource.connect(this.AUD_node);
    //   this.AUD_node.connect(this.AUD_destination);

    //   this.AUD_node.clipping = false;
    //   this.AUD_node.lastClip = 0;
    //   this.AUD_node.clipLag = 750;
    //   this.AUD_node.clipLevel = 0.98;
    //   this.AUD_node.averaging = 0.95;

    //   this.AUD_node.checkClipping = function() {
    //     if (!this.clipping) {
    //       return false;
    //     }
    //     if ((this.lastClip + this.clipLag) < window.performance.now()) {
    //       this.clipping = false;
    //     }
    //     return this.clipping;
    //   };

    //   this.AUD_node.shutdown =function() {
    //     this.disconnect();
    //     this.onaudioprocess = null;
    //   };

    //   this.AUD_node.onaudioprocess = this._onAudioNodeProcess;
    // },

    // _onAudioNodeProcess(event) {
    //   const buf = event.inputBuffer.getChannelData(0);
    //   const bufLength = buf.length;
    //   let sum = 0;
    //   let x;

    //   // Do a root-mean-square on the samples: sum up the squares...
    //   for (let i=0; i<bufLength; i++) {
    //     x = buf[i];
    //     if (Math.abs(x)>=this.AUD_node.clipLevel) {
    //       this.AUD_node.clipping = true;
    //       this.AUD_node.lastClip = window.performance.now();
    //     }
    //     sum += x * x;
    //   }

    //   // ... then take the square root of the sum.
    //   const rms = Math.sqrt(sum / bufLength);
    //   this.AUD_volumeMeter = Math.max(rms, this.AUD_volumeMeter * this.AUD_node.averaging);
    //   console.log(this.AUD_volumeMeter);
    // },
  },
};
